import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type { PluginFunctionParametersResponse } from 'types/PluginFunctionParameter';

const getPluginFunctionParameters = async (
  pluginFunctionID: string | null | undefined
) => {
  return fetchWrapper<PluginFunctionParametersResponse>({
    url: `pluginFunctionParameters?filter[pluginFunctionID]=${pluginFunctionID}`,
    method: 'GET',
  });
};

export function usePluginFunctionParameters(
  pluginFunctionID: string | null | undefined
) {
  return useQuery(
    ['pluginFunctionParameters', pluginFunctionID],
    () => getPluginFunctionParameters(pluginFunctionID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch Plugin Function Method Parameters: ${error.message}`
          );
        }
      },
      enabled: !!pluginFunctionID,
      ...CACHE_AND_STALE_TIME,
    }
  );
}
